<mat-sidenav-container [hasBackdrop]="false">
  <mat-sidenav
    mode="over"
    position="start"
    [style.width]="'auto'"
    [style.background-color]="'#381A99'"
    [opened]="isMenuOpen"
    >
    <div class="sidenav-logo" [style.margin]="'1rem 0.5rem'" (click)="onSelect('home')">
      <pop-ui-avatar [showFullName]="true"></pop-ui-avatar>
    </div>
    <ul [style.color]="'white'" [style.background-color]="'#381A99'" [style.list-style-type]="'none'" [style.padding]="'0 0.5rem'">
      @for (entry of entries[0]; track $index) {
        @if($index > 0) { <li role="menuitem" (click)="onSelect(entry)" class="menuItem">{{title(entry)}}</li> }
      }
    </ul>
    <mat-divider [style.background-color]="'white'" [style.margin]="'0 0.5rem 1rem'"></mat-divider>
    <ul [style.color]="'white'" [style.background-color]="'#381A99'" [style.list-style-type]="'none'" [style.padding]="'0 0.5rem'">
      @for (entry of entries[1]; track $index; let isLast = $last) {
        <li role="menuitem" (click)="onSelect(entry)" class='menuItem' [ngClass]="{'isLast': isLast}">{{title(entry)}}</li>
      }
    </ul>
  </mat-sidenav>
  <mat-sidenav-content #content>
    @if (!embedded) {<pop-ui-headerlte [(menu)]="isMenuOpen" [(activeTab)]="activeTab" [(classroom)]="classroom" [(profile)]="profile"></pop-ui-headerlte> }
    <div class="dashboard-container" [ngClass]="rootClassName" (click)="isMenuOpen = false">
      <div #tabsContentTopRef (scrollend)="onScrollEnd($event)"
        class="dashboard-content-container noscrollbar"
        [ngClass]="{'scrollable':!slideUp, 'footer':isFooterVisible}"
      >
        @if (slideUp) {
          <div class="dashboard-sliding-bottom-container">
            @if (profile) { <pop-ui-profile [userInfo]="userInfo" (action)="resetView()"></pop-ui-profile> }
            @if (legal) { <pop-ui-legal [legal]="legal" (action)="resetView()"></pop-ui-legal> }
            @if (isJoinActive) { <pop-ui-join-classroom [(classroom)]="classroom" (action)="resetView()"></pop-ui-join-classroom> }
          </div>
        }
        <div #tabsContentRef class="dashboard-content container p-0">
          @if (!slideUp) {
            @if (isHeaderVisible) {
              <pop-ui-dashboard-content-header
                [(navigation)]="navigation"
                [(search)]="search"
                [template]="template"
                [collapsed]="collapsed"
              ></pop-ui-dashboard-content-header>
            }
            @switch (activeTab) {
              @case ('library') { <pop-ui-library [(state)]="tabState" [(search)]="search" [collapsed]="collapsed"></pop-ui-library> }
              @case ('performance') { <pop-ui-performance [(state)]="tabState" [(search)]="search"></pop-ui-performance> }
              @default { <pop-ui-home [activeDate]="activeDate" [(state)]="homeState" [(search)]="search" [(tiles)]="tiles" (handlebarAction)="onHandlebarAction($event)"></pop-ui-home> }
            }
          }
        </div>
      </div>
      @if (isFooterVisible) {
        @defer { <pop-ui-footerlte [(legal)]="legal"></pop-ui-footerlte> }
      }
      <div class="to-top" (click)="scrollToTop()" [ngClass]="{'web':isWeb, 'show-scrollTop': windowScrolled, 'bottom':!isFooterVisible}" title="scroll to top">
        <img loading="lazy" src="/assets/icons/triangle.svg" alt="to-top-icon" width="14" height="6" />
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

@if (isTourVisible) {
  <div class="tour-menu">
    <button type="button" class="btn btn-outline-dark btn-sm" [matMenuTriggerFor]="menu">Tours</button>
    <mat-menu #menu="matMenu">
      <ng-template matMenuContent>
        @for (tour of tours; track $index) {
          <button mat-menu-item (click)="startTour(tour.id)">{{tour.name}}</button>
        }
      </ng-template>
    </mat-menu>
  </div>
}

@if (!isInFrame) {
  <pop-ui-cookie-banner></pop-ui-cookie-banner>
}
<ng-template #_confirmLogout>
  <div class="modal-header border-0">
    <h4 class="modal-title pull-left headingboldsmall">Are you sure ?</h4>
  </div>
  <div class="modal-body">
    <p>This action will sign you out</p>
    <div class="text-center">
      <button type="button" class="btn btn-primary" (click)="onSelect('cancel')">Cancel</button>
      <button type="button" class="btn btn-default" (click)="onSelect('Sign Out')">I don't care. Sign out</button>
    </div>
  </div>
</ng-template>
